import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import { noop } from "lodash";
import React, { Fragment } from "react";

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: 'white',
    borderRadius: 0,
    boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.1) inset',
    "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {}
  },
  disabled: {
    backgroundColor: '#d0d0d0'
  },
  focused: {
    border: '1px solid #E0B334 ',
  },
  error: {
    border: '1px solid #E01F0D',
  },
  notchedOutline: {
    border: '0px !important',
  },
  // TextareaAutosize measures the content and writes height and overflow
  // straight onto the node after render, so an inline height of 100% is gone
  // by the time it paints — the box collapsed to its own padding. A class can
  // outrank that; an inline style cannot.
  input: {
    color: '#000000',
    height: '100% !important',
    overflow: 'auto !important',
    boxSizing: 'border-box',
    padding: '22px 18px',
  },
  shrink: {
    display: 'none'
  }
});

const TextBox = (props) => {
  const { onAnswered = noop, value, classes, height = '350px' } = props;

  const handleChange = (e) => {
    onAnswered(e.target.value);
  };

  return (
    <Fragment>
      <TextField
        {...props}
        value={value ?? ''}
        multiline={true}
        onChange={handleChange}
        variant="outlined"
        fullWidth
        InputLabelProps={{
          classes: {
            focused: classes.shrink
          }
        }}
        InputProps={{
          classes: {
            root: classes.root,
            notchedOutline: classes.notchedOutline,
            focused: classes.focused,
            error: classes.error,
            input: classes.input
          },
          style: {
            height,
            padding: 0
          }
        }}
        inputProps={{
          style: {
            whiteSpace: 'normal',
            wordBreak: 'break-all',
            overflowWrap: 'anywhere'
          }
        }}
      />
    </Fragment>
  );
};

export default withStyles(styles)(TextBox);
